import { initAxios, isAuthorisationError } from '@onhandtech/onhand-fe-shared/lib/axios'
import { getFirebaseAuth, logout } from '@onhandtech/onhand-fe-shared/lib/firebase'
import type { InternalAxiosRequestConfig } from 'axios'
import type { Config } from 'config/configuration'

import { getRoutePath } from '../router/router.utils'

// eslint-disable-next-line no-underscore-dangle
let _accessToken: string | null = null

export const setAccessToken = (accessToken: string) => {
  _accessToken = accessToken
}

export const startApi = (config: Config) => {
  initAxios({
    baseURL: config.domains.apiHost,
    interceptors: {
      request: requestInterceptor,
      response: responseInterceptor,
    },
  })
}

export const requestInterceptor = async (request: InternalAxiosRequestConfig<any>) => {
  if (_accessToken) {
    request.headers.Authorization = `Bearer ${_accessToken}`
    request.headers.AccessToken = _accessToken
    return request
  }

  const firebaseAuth = getFirebaseAuth()

  if (firebaseAuth?.currentUser) {
    firebaseAuth.currentUser
      .getIdToken()
      .then((accessToken) => {
        _accessToken = accessToken
        request.headers.Authorization = `Bearer ${accessToken}`
        request.headers.AccessToken = accessToken
      })
      .catch(() => {})
  }

  return request
}

// Have to use 'any' since that's the type Axios tells us :/
export const responseInterceptor = (error: any) => {
  if (isAuthorisationError(error)) {
    logout()
    window.location.replace(getRoutePath('SIGN_IN'))
  }

  return error
}
